import styled, { css } from 'styled-components';
import { InputReactWrapper } from '../../input';
import type { DateRangePickerProps } from '../DateRangePicker';

export const StyledInput = styled(InputReactWrapper)<DateRangePickerProps>`
  &&&& {
    cursor: pointer;
    box-sizing: border-box !important;
    border-radius: var(--ant-border-radius);

    .clear-icon,
    .calendar-icon {
      margin: 0;
      transition: 0.2s ease-in-out;
    }

    .clear-icon {
      display: none;
    }

    :hover {
      .calendar-icon {
        display: none;
      }

      .clear-icon {
        display: block;
        color: ${({ theme }) => theme.color.grey.grey5};
      }
      .clear-icon:hover {
        color: ${({ theme }) => theme.color.grey.grey9};
      }
    }

    ${({ disabled }) =>
      disabled &&
      css`
        border-color: transparent;
        background-color: ${({ theme }) => theme.color.semantic.primary.background.disabled};

        .ant-input-group-addon {
          border: none;
          background-color: ${({ theme }) => theme.color.semantic.primary.background.disabled};
        }

        button {
          background-color: ${({ theme }) => theme.color.semantic.primary.background.disabled};
        }

        svg {
          pointer-events: none;
          color: ${({ theme }) => theme.color.semantic.primary.type.disabled};
        }
      `}

    // Focus ring wraps the entire component including addon buttons
    &:focus-within {
      box-shadow: 0 0 0 2px ${({ theme }) => theme.color.semantic.focus.border};
      border-radius: var(--ant-border-radius);
    }

    .ant-input-affix-wrapper {
      box-shadow: none;
      border-left: none;
      border-right: none;
    }

    .ant-input-group-addon {
      padding: 0;
      background: none;
      z-index: 2;
    }

    .ant-input-group-addon:first-child {
      border-right: none;
      ::after {
        content: '';
        position: absolute;
        border-left: 1px solid ${({ theme }) => theme.color.grey.grey4};
        right: -1px;
        top: 7px;
        height: 16px;
      }
    }

    .ant-input-group-addon:last-child {
      border-left: none;
      ::before {
        content: '';
        position: absolute;
        border-left: 1px solid ${({ theme }) => theme.color.grey.grey4};
        left: -1px;
        top: 7px;
        height: 16px;
      }
    }

    button {
      padding: 0;
      position: relative;
      height: 30px;
      color: ${({ theme }) => theme.color.grey.grey6};
      background-color: transparent;
      border: none;
      box-shadow: none;
    }
  }
`;
